import { render, staticRenderFns } from "./ConversationDetails.vue?vue&type=template&id=c928bd5e&"
import script from "./ConversationDetails.vue?vue&type=script&lang=js&"
export * from "./ConversationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConversationDetails.vue?vue&type=style&index=0&id=c928bd5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports